<template>
  <div class="config">
    <UploaderElementUi @changeConfig="changeConfig" :element="element" :image="element.config.url ? element.config.url : ''"/>
    <NumberInput @changeConfig="changeConfig" :element="element"  :zIndex="element.config.zIndex ? element.config.zIndex : ''"/>
  </div>
</template>

<script>
import UploaderElementUi from "@/components/Widgets/Image/UploaderElementUi";
import NumberInput from "@/components/Inputs/NumberInput";

export default {
  name: "ImageWidgetConfig",
  components: {
    NumberInput,
    UploaderElementUi,
  },
  props: {
    element: {}
  },
  methods:{
    changeConfig(data){
      this.$emit('changeConfig',data);
    }
  }
}
</script>

<style scoped>

</style>
